export default __webpack_public_path__ + "static/media/grandbama.2aacdad1.jpg";